module.exports = __webpack_public_path__ + "img/feetCombination.ba35b19c.svg";